import SiafLiteApiRepository from "../../external/siafLiteApi";

class ConsultasLoteService {
  constructor() {
    this.urlBase = "/estoque/consultas-lote";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  cancelar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id);
  }
}

export default ConsultasLoteService;
